import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { style: {"padding-top":"1rem"} }
const _hoisted_3 = {
  key: 0,
  class: "submitcontent"
}

import { onMounted, ref,computed,watch} from "vue";
import {showToast,showLoadingToast} from 'vant'
import TimePicker from "@/components/TimePicker/TimePicker.vue";
import ZCell from "@/components/ZCell/ZCell.vue";
import UploadImage from "@/components/UploadImage/UploadImage.vue";
import weChatMerchantMemberApi from "@/utils/Api/WeChatMerchantMember"
import {useRoute} from "vue-router";
import dic from "@/assets/ts/dictionary";
import router from "@/router";


export default /*@__PURE__*/_defineComponent({
  __name: 'accountdetail',
  setup(__props) {

const route=useRoute();


onMounted(() => {
  document.title = route.query.look?'查看会员':(route.query.id?'编辑会员':'新增会员');
  if(route.query.id){
    getDetail();
  }
})

const form = ref({
  companyName:"",
  contactName:"",
  merchantCategory:1,
  merchantCategoryName:'',
  incorporationTime:"",
  employeeTotal:null,
  contactPhone:"",
  companyAdddress:"",
  longinAccount:"",
  longoutPassword:"",
  merchantStatus:true,
  merchantCover:[],
  companyDesc:"",
  "auditStatus": 0
})
let loading='';
const getDetail=()=>{
  loading=showLoadingToast({
    forbidClick: true,
  });
  weChatMerchantMemberApi.detail(route.query.id).then(res=>{
    form.value=res.data;
    let merchantCover=[];
    merchantCover.push(res.data.merchantCover)
    form.value.merchantCover=merchantCover;

    for(let i in dic.getDicList('merchantCategoryStatus')){
      if(dic.getDicList('merchantCategoryStatus')[i].value== form.value.merchantCategory){
        form.value.merchantCategoryName=dic.getDicList('merchantCategoryStatus')[i].label
        break;
      }
    }
  }).finally(()=>{
    loading.close();
  })
}

//提交
const onSubmit = (values: any) => {
  console.log('submit1', values);
  console.log(   form.value,
      form.value.merchantCover?.[0])
  loading=showLoadingToast({
    forbidClick: true,
  });
  weChatMerchantMemberApi.updateOrAdd(route.query.id?1:0, {
    ...form.value,
    merchantCover:form.value.merchantCover?.[0]
    }).then(()=>{
      showToast({
        message:route.query.id?'编辑成功':'新增成功',
        onClose:()=>{
          router.push('/accountapply')
        }
      });
    }).finally(()=>{
      loading.close();
    })

}
const show = ref(false);
const customFieldName = {
  text: 'label'
};
const onConfirmMerchant = ({selectedOptions}) => {
  show.value = false;
  console.log(selectedOptions)
  form.value.merchantCategoryName = selectedOptions[0].label;
  form.value.merchantCategory= selectedOptions[0].value;
}
const getImgList=(formName:any,data:any)=>{
  console.log(formName,data)
  form.value[formName]=data;
}


return (_ctx: any,_cache: any) => {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      title: _unref(route).query.look?'查看会员':(_unref(route).query.id?'编辑会员':'新增会员'),
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1)))
    }, null, 8, ["title"]),
    _createVNode(_component_van_form, {
      onSubmit: onSubmit,
      disabled: _unref(route).query.look,
      "show-error": "",
      "show-error-message": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(ZCell, {
            label: "公司类型",
            require: "",
            class: _normalizeClass(['cell-input',form.value.merchantCategory!==''?'':'empty'])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: form.value.merchantCategoryName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.merchantCategoryName) = $event)),
                placeholder: _unref(route).query.look?'':'请选择',
                rules: [{ required: true, message: '请选择' }],
                onClick: _cache[2] || (_cache[2] = ($event: any) => (show.value = true))
              }, null, 8, ["modelValue", "placeholder"]),
              _createVNode(_component_van_popup, {
                show: show.value,
                "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((show).value = $event)),
                round: "",
                position: "bottom"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_picker, {
                    columns: _unref(dic).getDicList('merchantCategoryStatus'),
                    onCancel: _cache[3] || (_cache[3] = ($event: any) => (show.value = false)),
                    onConfirm: onConfirmMerchant,
                    "columns-field-names": customFieldName
                  }, null, 8, ["columns"])
                ]),
                _: 1
              }, 8, ["show"])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(ZCell, {
            label: "公司名称",
            hiddenArrow: "",
            require: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: form.value.companyName,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.companyName) = $event)),
                placeholder: _unref(route).query.look?'':'请输入',
                rules: [{ required: true, message: '请填写公司名称' }]
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(ZCell, {
            label: "成立日期",
            require: ""
          }, {
            default: _withCtx(() => [
              _createVNode(TimePicker, {
                modelValue: form.value.incorporationTime,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.incorporationTime) = $event)),
                readonly: _unref(route).query.look,
                rules: [{ required: true, message: '请填写' }]
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(ZCell, {
            label: "职工人数",
            hiddenArrow: "",
            require: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: form.value.employeeTotal,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.employeeTotal) = $event)),
                placeholder: _unref(route).query.look?'':'请输入',
                rules: [{ required: true, message: '请填写职工人数' }]
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(ZCell, {
            label: "会员名称",
            hiddenArrow: "",
            require: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: form.value.contactName,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.contactName) = $event)),
                placeholder: _unref(route).query.look?'':'请输入',
                rules: [{ required: true, message: '请填写会员名称' }]
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(ZCell, {
            label: "服务电话",
            hiddenArrow: "",
            require: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: form.value.contactPhone,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.contactPhone) = $event)),
                type: "tel",
                placeholder: _unref(route).query.look?'':'请输入',
                rules: [{ required: true, message: '请填写服务电话' }]
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(ZCell, {
            label: "公司地址",
            hiddenArrow: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: form.value.companyAdddress,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.companyAdddress) = $event)),
                placeholder: _unref(route).query.look?'':'请输入',
                rules: [{ required: true, message: '请填写公司地址' }]
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(ZCell, {
            label: "登录账号",
            hiddenArrow: "",
            require: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: form.value.longinAccount,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.longinAccount) = $event)),
                placeholder: _unref(route).query.look?'':'请输入',
                rules: [{ required: true, message: '请填写登录账号' }]
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(ZCell, {
            label: "会员状态",
            hiddenArrow: "",
            require: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_radio_group, {
                disabled: _unref(route).query.look,
                class: "van-cell",
                modelValue: form.value.merchantStatus,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.merchantStatus) = $event)),
                direction: "horizontal",
                rules: [{ required: true, message: '请填写会员状态' }]
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dic).getDicList('memberStatus'), (item, index) => {
                    return (_openBlock(), _createBlock(_component_van_radio, {
                      name: item.value,
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["disabled", "modelValue"])
            ]),
            _: 1
          }),
          _createVNode(ZCell, {
            label: "公司封面",
            hiddenArrow: "",
            style: {"align-items":"flex-start!important"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(UploadImage, {
                  count: 1,
                  disabled: _unref(route).query.look,
                  list: form.value.merchantCover,
                  "aspect-ratio": 5/4,
                  onGetImgList: _cache[13] || (_cache[13] = e=>getImgList('merchantCover',e))
                }, null, 8, ["disabled", "list"])
              ])
            ]),
            _: 1
          }),
          _createVNode(ZCell, {
            label: "公司简介",
            hiddenArrow: "",
            style: {"align-items":"flex-start!important"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: form.value.companyDesc,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.companyDesc) = $event)),
                rows: "6",
                autosize: "",
                type: "textarea",
                placeholder: _unref(route).query.look?'':'请输入',
                rules: [{ required: true, message: '请填写公公司简介' }]
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _cache[16] || (_cache[16] = _createElementVNode("div", { style: {"height":"12.5rem"} }, null, -1)),
          (!_unref(route).query.look)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_van_button, {
                  round: "",
                  block: "",
                  class: "primary-btn",
                  type: "primary",
                  "native-type": "submit"
                }, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                    _createTextVNode(" 提交 ")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["disabled"])
  ], 64))
}
}

})